<template>
  <div>
    <!-- 上传图片dialog -->
    <el-dialog
      ref="editDialog"
      :visible.sync="dialogUploadFormVisible"
      :before-close="closeUploadForm"
      :close-on-click-modal="false"
      :title="$l('tips_add_file') || '文件上传'"
      top="0vh"
      width="1000px"
    >
      <image-edit
        v-if="dialogUploadFormVisible"
        :scmCode="scmCode"
        @close="closeUploadForm"
        @save="uploadOk"
      />
    </el-dialog>

    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :data="tableData"
      :columns="tableColumn"
      :height="tableHeight - 44"
      :toolbar-config="tableToolbar"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button size="sm" variant="outline-success" @click="uploadImage()">
            <b-icon-plus></b-icon-plus>
            {{ $l('tips_add_file') || '上传文件' }}
          </b-button>
        </slot>
      </template>
      <template v-slot:fileType="{ row }">
        <span
          v-if="
            ['jpeg', 'png', 'jpg', 'gif'].includes(
              row.scmImageCode.substring(row.scmImageCode.indexOf('.') + 1)
            )
          "
          >图片</span
        >
        <span v-else>文件</span>
      </template>
      <template v-slot:imageUrl="{ row }">
        <div
          v-if="
            ['jpeg', 'png', 'jpg', 'gif'].includes(
              row.scmImageCode.substring(row.scmImageCode.indexOf('.') + 1)
            )
          "
        >
          <el-image
            :src="
              row.scmImageUrl
                ? $osscdn(row.scmImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            style="width:100px; height:66px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 100px; height: 66px"
              />
            </div>
          </el-image>
        </div>
        <span v-else>{{
          row.scmImageCode.substring(row.scmImageCode.indexOf('.') + 1)
        }}</span>
      </template>
      <template v-slot:uploadBy="{ row }">
        <b-avatar :src="row.memImgUrl ? $osscdn(row.memImgUrl) : ''"></b-avatar>
        <span class="ml-3">{{ row.userNameEn }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="showEdit(row, row.scmCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.scmInfoImageCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="dowloadFile(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <div slot="empty">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </div>
    </vxe-grid>
    <pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="small"
      align="right"
      slot="pager"
      @change="handlePaginationChange"
    />
    <!--编辑弹框-->
    <el-dialog
      ref="editDialog"
      title="编辑说明"
      :visible.sync="dialogEditFormVisible"
      :before-close="closeEditForm"
      :close-on-click-modal="false"
      width="550px"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form ref="formData">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  :label="$l('label_file_desc') || '文件说明'"
                  prop="scmCode"
                >
                  <el-input
                    v-model="curScmImageDesc"
                    :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                    maxlength="100"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 3 }"
                    show-word-limit
                    clearable
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeEditForm">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button size="medium" type="primary" @click="updateDesc">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImageEdit from './components/edit.vue'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  components: {
    ImageEdit,
  },
  props: {
    scmCode: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      dialogEditFormVisible: false,
      dialogUploadFormVisible: false,
      curScmInfoImageCode: '',
      curScmImageDesc: '',
      tableData: [],
      formData: {},
      params: {
        scmCode: '',
      },
      tableColumn: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('table_label_operation') || '操作',
          align: 'center',
          width: 120,
          //fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'fileType',
          width: 100,
          title: this.$l('label_file') || '文件类型',
          align: 'center',
          slots: { default: 'fileType' },
        },
        {
          field: 'scmImageUrl',
          width: 180,
          align: 'center',
          title: this.$l('form_label_image') || '图片',
          slots: { default: 'imageUrl' },
        },
        {
          headerAlign: 'center',
          field: 'scmImageDesc',
          minWidth: 200,
          title: this.$l('label_file_desc') || '说明',
        },
        {
          align: 'center',
          field: 'userNameEn',
          width: 200,
          title: this.$l('form_label_image_uploadby') || '上传人',
        },
        {
          align: 'center',
          field: 'createTime',
          width: 170,
          title: this.$l('doc_table_label_upload_time') || '上传时间',
        },
      ],
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
    }
  },
  watch: {
    scmCode: {
      handler(scmCode) {
        if (scmCode !== '') {
          this.init(scmCode)
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    init(scmCode) {
      this.params.scmCode = scmCode
      this.getData()
    },
    getData() {
      if (this.scmCode === '') return
      this.loading = true
      this.$api
        .scmInfoImageListApi({ scmCode: this.scmCode, ...this.page })
        .then((res) => {
          this.tableData = res.body.data
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
    },
    reload() {
      this.getData()
    },
    showEdit(row) {
      this.curScmInfoImageCode = row.scmInfoImageCode
      this.curScmImageDesc = row.scmImageDesc
      this.dialogEditFormVisible = true
    },
    updateDesc() {
      this.loading = true
      let params = {
        scmInfoImageCode: this.curScmInfoImageCode,
        scmImageDesc: this.curScmImageDesc,
      }
      this.$api
        .scmInfoUpdateImageDescApi(params)
        .then(() => {
          this.loading = false
          this.dialogEditFormVisible = false
          this.reload()
        })
        .catch(() => {
          this.loading = false
        })
    },
    closeEditForm() {
      this.dialogEditFormVisible = false
    },
    del(scmInfoImageCode) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .scmInfoImageDelApi({ scmInfoImageCode: scmInfoImageCode })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_operate_ok') || '操作成功!'
            )
            this.reload()
          })
      })
    },
    uploadImage() {
      this.dialogUploadFormVisible = true
    },
    closeUploadForm() {
      this.dialogUploadFormVisible = false
    },
    uploadOk() {
      this.dialogUploadFormVisible = false
      this.reload()
    },
    // 下载文件
    dowloadFile(row) {
      window.open(this.$osscdn(row.scmImageUrl))
    },
  },
}
</script>
